import { ErrorCode } from '@approvalmax/types';
import { toast } from '@approvalmax/ui/src/components';
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetWallets } from 'shared/data/wallets/v1';
import { useCompanyBasedOnUrl } from 'shared/hooks';
import { getPath, Path } from 'urlBuilder';

import { fundWalletPopupState } from '../../../FundWalletPopup/FundWalletPopup.states';
import { convertCurrencyPopupState } from '../ConvertCurrencyPopup/ConvertCurrencyPopup.states';
import { messages } from './WalletsTabActions.messages';

export const useHandlers = () => {
    const { id: companyId, defaultCurrency } = useCompanyBasedOnUrl();

    const { push } = useHistory();
    const { data, isLoading } = useGetWallets(
        {
            path: { organizationId: companyId },
        },
        {
            onError: (error) => {
                if (error.code === ErrorCode.OrganizationNotFound) {
                    push(getPath(Path.walletsKyc, companyId));
                }
            },
        },
        {
            skipToastForErrorCodes: [ErrorCode.OrganizationNotFound],
        }
    );

    const setFundWalletPopup = useSetAtom(fundWalletPopupState);
    const setConvertCurrencyPopupState = useSetAtom(convertCurrencyPopupState);

    const handleFundClick = useCallback(() => {
        const fundableWallets = data?.items.filter((item) => item.isFundable);

        if (!fundableWallets?.length) {
            toast.error(messages.fundingNotAvailable);

            return;
        }

        const defaultCurrencyWallet = fundableWallets.find(
            (item) => item.currency.code.toUpperCase() === defaultCurrency.toUpperCase()
        );

        if (defaultCurrencyWallet) {
            setFundWalletPopup({
                currencyCode: defaultCurrencyWallet.currency.code,
                walletId: defaultCurrencyWallet.id,
            });

            return;
        }

        setFundWalletPopup({ currencyCode: fundableWallets[0].currency.code, walletId: fundableWallets[0].id });
    }, [data, setFundWalletPopup, defaultCurrency]);

    const handleConvertClick = useCallback(() => {
        setConvertCurrencyPopupState({
            isOpen: true,
        });
    }, [setConvertCurrencyPopupState]);

    return {
        isLoading,
        handleFundClick,
        handleConvertClick,
    };
};
